export default __webpack_public_path__ + "static/media/minus.0bb88084.svg";